import { render, staticRenderFns } from "./ProcessContext.vue?vue&type=template&id=64defbb8&scoped=true"
import script from "./ProcessContext.vue?vue&type=script&lang=js"
export * from "./ProcessContext.vue?vue&type=script&lang=js"
import style0 from "./ProcessContext.vue?vue&type=style&index=0&id=64defbb8&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64defbb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardSubtitle,VCardText})
